import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

// FRS 4.2.1 (revision 20260826) - VRF System = 1 Outdoor + N Indoor (with quantity)
// scaffold: BE endpoint /vrf_system/ ยังไม่ถูกสร้าง (Phase 1-2) — สัญญา payload ด้านล่าง
// เป็นข้อเสนอ ต้อง sync กับ serializer จริงตอน BE พร้อม
export const ACTION = {
  LIST: 'LIST_VRF_SYSTEM',
  GET: 'GET_VRF_SYSTEM',
  CREATE: 'CREATE_VRF_SYSTEM',
  EDIT: 'EDIT_VRF_SYSTEM',
  DELETE: 'DELETE_VRF_SYSTEM',
  DUPLICATE: 'DUPLICATE_VRF_SYSTEM',
  CLEAR_ERROR: 'CLEAR_ERROR_VRF_SYSTEM',
};

export const clearErrorVRFSystem = () => ({ type: ACTION.CLEAR_ERROR });

const searchVRFSystem = (
  pageSize,
  page,
  sorted,
  filtered,
  isPublic,
  excludeZoneId = null,
) => {
  const zoneParams = excludeZoneId && { not__zone_id: excludeZoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_VRF_SYSTEM,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => (sort.desc ? `-${sort.id}` : sort.id)).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const searchVRFSystemByText = (text, page = 0, excludeZoneId = null) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  return searchVRFSystem(
    pageSize,
    page,
    withDefaultSort([]),
    text,
    null,
    excludeZoneId,
  );
};

export const listVRFSystem = (pageSize, page, sorted, filtered, isPublic) => ({
  type: ACTION.LIST,
  payload: searchVRFSystem(pageSize, page, sorted, filtered, isPublic).catch(
    err => Promise.reject(err.response.data),
  ),
});

export const getVRFSystem = id => ({
  type: ACTION.GET,
  payload: RestClient.request({
    method: 'get',
    url: `${Constants.API_VRF_SYSTEM}${id}/`,
  }).catch(err => Promise.reject(err.response.data)),
});

// indoorItems: [{ indoorTypeId, quantity }]
const buildPayload = (
  { name, outdoorId, indoorItems, description },
  partial,
) => {
  const data = {};
  if (!partial || name !== undefined) data.name = name;
  if (!partial || outdoorId !== undefined) data.outdoor_id = outdoorId;
  if (Array.isArray(indoorItems)) {
    data.indoor_items = indoorItems
      .filter(it => it && it.indoorTypeId)
      .map(it => ({
        indoor_type_id: it.indoorTypeId,
        quantity: Number(it.quantity) || 1,
      }));
  }
  if (typeof description === 'string') data.description = description;
  return data;
};

export const createVRFSystem = params => ({
  type: ACTION.CREATE,
  payload: RestClient.request({
    method: 'post',
    url: Constants.API_VRF_SYSTEM,
    data: buildPayload(params, false),
  }).catch(err => Promise.reject(err.response.data)),
});

export const editVRFSystem = (id, params) => ({
  type: ACTION.EDIT,
  payload: RestClient.request({
    method: 'patch',
    url: `${Constants.API_VRF_SYSTEM}${id}/`,
    data: buildPayload(params, true),
  }).catch(err => Promise.reject(err.response.data)),
});

export const deleteVRFSystem = id => ({
  type: ACTION.DELETE,
  payload: RestClient.request({
    method: 'delete',
    url: `${Constants.API_VRF_SYSTEM}${id}/`,
  })
    .then(() => ({ id }))
    .catch(err => Promise.reject(err.response.data)),
});

export const duplicateVRFSystem = (id, name) => ({
  type: ACTION.DUPLICATE,
  payload: RestClient.request({
    method: 'post',
    url: `${Constants.API_VRF_SYSTEM}${id}/copy/`,
    data: { new_name: name },
  }).catch(err => Promise.reject(err.response.data)),
});



// WEBPACK FOOTER //
// ./src/redux/vrf/vrf_system_actions.js